<template>
  <generic-container
    class="ui tab form segment"
    :title="$t('variables')"
    icon="chess knight"
    :show_plus="true"
    :searchable="true"
    @add="add"
  >
    <div class="five column wide field">
      <label for>{{ $t("environment") }}</label>
      <div class="ui selection dropdown" ref="environment_dropdown">
        <input type="hidden" name="gender" />
        <i class="dropdown icon"></i>
        <div class="default text">{{ $t("select one") }}</div>
        <div class="menu">
          <div class="item" data-value="development">
            {{ $t("development") }}
          </div>
          <div class="item" data-value="testing">{{ $t("testing") }}</div>
          <div class="item" data-value="production">{{ $t("production") }}</div>
        </div>
      </div>
    </div>

    <h4 class="ui dividing header">{{ $t("variables") }}</h4>
    <div
      v-bind:class="{ hidden: item.environment != selected_environment }"
      class="two fields"
      v-for="(item, index) in variables"
      :key="index"
    >
      <div class="fourteen wide column field">
        <label for>{{ item.name }}</label>
        <input type="text" v-model="variables[index].value" />
      </div>
      <div class="two column wide field">
        <label for>{{ $t("options") }}</label>
        <div
          class="ui red icon mini labeled button"
          @click="remove(item, index)"
        >
          <i class="trash icon"></i>
          {{ $t("delete") }}
        </div>
      </div>
    </div>
  </generic-container>
</template>

<script>
import GenericContainer from "@/components/GenericContainer";
import filters from "@/filters";

export default {
  name: "VariablesManagement",
  filters: filters,
  props: { project: Object },
  components: {
    GenericContainer,
  },
  data() {
    return {
      variables: [],
      selected_environment: "",
    };
  },
  computed: {},
  created() {},
  methods: {
    add() {
      let vm = this;
      this.$alertify.prompt(this.$t("variable name"), "", function(
        $element,
        comment,
      ) {
        vm.variables.push({
          name: comment,
          value: "",
          environment: "development",
        });
        vm.variables.push({
          name: comment,
          value: "",
          environment: "testing",
        });
        vm.variables.push({
          name: comment,
          value: "",
          environment: "production",
        });
      });
    },
    remove(variable) {
      let vm = this;
      vm.$alertify.confirm(
        vm.$t("are you sure to delete variable?"),
        function() {
          vm.variables = vm.variables.filter((n) => n.name != variable.name);
        },
      );
    },
    updateVariables() {
      let vm = this;
      // console.log("updating variables");
      vm.variables = vm.$props.project.setup.variables || [];
    },
  },
  mounted() {
    let vm = this;
    // setTimeout(function() {
    //   vm.variables = vm.$props.project.setup.variables || [];
    // }, 1000);

    window
      .jQuery(vm.$refs.environment_dropdown)
      .dropdown({
        onChange(value) {
          vm.selected_environment = value;
        },
      })
      .dropdown("set selected", "development");
  },
  watch: {},
};
</script>
